import LoginOtp from "../views/login-otp/LoginOtp.vue";

const loginOtp = {
    
  path: '/login-otp',
  name: 'LoginOTP',
  meta: {
    title: 'BNI QRIS - Login OTP',
    appBarTitle: 'Login OTP',
  },
  component: LoginOtp
};

export default loginOtp;